var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.58594 15.4961H20.6693M20.6693 15.4961L16.1484 11.6211M20.6693 15.4961L16.1484 19.3711",
    stroke: "#D45A07",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.625 9.04036C11.6405 6.23099 11.7658 4.70941 12.7578 3.71741C13.8932 2.58203 15.7196 2.58203 19.3724 2.58203H20.6641C24.3182 2.58203 26.1446 2.58203 27.28 3.71741C28.4141 4.85149 28.4141 6.6792 28.4141 10.332V20.6654C28.4141 24.3182 28.4141 26.1459 27.28 27.28C26.2867 28.2733 24.7651 28.3973 21.9557 28.4128M11.625 21.957C11.6405 24.7664 11.7658 26.288 12.7578 27.28C13.5857 28.1092 14.7831 28.3327 16.7891 28.3934",
    stroke: "#D45A07",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginIcon);
export default __webpack_public_path__ + "static/media/loginIcon.81c856f91aa1e4e066a71cd3d4ac05d2.svg";
export { ForwardRef as ReactComponent };